import React from 'react';

const DoctorsMessagePatternMob = ({ className }) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" width="100%" height="100%" viewBox="0 0 428 805" fill="none">
      <path d="M242.773 0C308.181 146.007 165.497 302.794 0 220.065V0H242.773Z" fill="#7F4A9B" />
      <path d="M293.022 805C256.656 723.885 335.986 636.781 428 682.742L428 805L293.022 805Z" fill="#7F4A9B" />
    </svg>
  );
};

export default DoctorsMessagePatternMob;